import Constant from '@/const'
import Store from '@/store/index.js'
import { stringify } from 'querystring'
export default {
  namespaced: true,
  state: {
    meihenFlg: null,
    JYUCYU_SHIKI_CD: null,
    TANTO_ID: null,
    LEASE_KAISHA_KBN: null,
    data: {}, // 発注データ
    nextConfirmFlg: false, // 発注確認画面遷移
  },
  okiniiri: {
    meihenFlg: null,
    JYUCYU_SHIKI_CD: null,
  },
  mutations: {
    create(state, data) {
      state.meihenFlg = data.meihenFlg
    },
    destroy(state) {
      state.meihenFlg = null
      state.JYUCYU_SHIKI_CD = null
      state.TANTO_ID = null
      state.LEASE_KAISHA_KBN = null
      state.data = {}
    },
    setOrder(state, data) {
      state.data = data
    },
    setNextConfirmFlg(state) {
      state.nextConfirmFlg = !state.nextConfirmFlg
    },
    destroyOrder(state) {
      state.data = {}
    },
  },
  actions: {
    // 顧客別登録場所
    getTransports({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.TOROKUBASHO}`,
        params: data,
        error: { message: '顧客別登録場所の取得に失敗しました。' },
      }
      return dispatch('http/get', { ...request }, { root: true })
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // お気に入り取得
    getOkiniiri({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.OKINIIRI}`,
        params: data,
        error: { message: 'お気に入りの取得に失敗しました。' },
      }
      return dispatch('http/get', { ...request }, { root: true }).then(
        (res) => res.data
      )
    },
    // お気に入り更新
    updateOkiniiri({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.OKINIIRI}`,
        params: data,
        error: { message: 'お気に入りの更新に失敗しました。' },
      }
      return dispatch('http/post', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
    // お気に入り削除
    deleteOkiniiri({ commit, dispatch }, id) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.OKINIIRI}/${id}`,
        error: { message: 'お気に入りの削除に失敗しました。' },
      }
      return dispatch('http/delete', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
    // ナンバープレートお気に入り取得
    getNumberPlateOkiniiri({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.NUMBERPLATE_OKINIIRI}`,
        params: data,
        error: { message: 'お気に入りの取得に失敗しました。' },
      }
      return dispatch('http/get', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
    // お気に入り登録
    async setOkiniiri({ commit, dispatch }, data) {
      const request = {
        url: `${Constant.API_URL.OKINIIRI}`,
        params: data,
        error: { message: 'お気に入りの登録に失敗しました。' },
      }
      await dispatch('http/post', { ...request }, { root: true })
        .then((res) => {})
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // テンプレート取得
    getTemplate({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.TEMPLATE}/${data.tantoId}&${data.keyword}`,
        error: { message: 'テンプレートの取得に失敗しました。' },
      }
      return dispatch('http/get', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
    // テンプレート登録
    async setTemplate({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.TEMPLATE}`,
        params: data,
        error: { message: 'テンプレートの登録に失敗しました。' },
      }
      await dispatch('http/post', { ...request }, { root: true })
        .then((res) => {})
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // テンプレート更新
    async updateTemplate({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.TEMPLATE}/${data.TEMPLATE_ID}`,
        params: data,
        error: { message: 'テンプレートの更新に失敗しました。' },
      }
      await dispatch('http/put', { ...request }, { root: true })
        .then((res) => {})
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // テンプレート削除
    async deleteTemplate({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.TEMPLATE}/${data.TEMPLATE_ID}`,
        error: { message: 'テンプレートの削除に失敗しました。' },
      }
      await dispatch('http/delete', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },

    // 発注情報取得
    getJyucyu({ commit, dispatch }, { tantoId, prefCd, cityCd, type }) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        params: { prefCd, cityCd, type },
        url: `${Constant.API_URL.JYUCYU}/get_list`,
        error: { message: '発注情報の取得に失敗しました。' },
      }
      return dispatch('http/post', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
    // 発注情報登録
    async setJyucyu({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: Constant.API_URL.JYUCYU,
        params: data,
      }
      await dispatch('http/post', { ...request }, { root: true })
        .then((res) => {})
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // オークション会場取得
    getAuctions({ commit, dispatch }, data) {
      const request = {
        url: `${Constant.API_URL.AUCTION}`,
        params: data,
        error: { message: 'オークション会場の取得に失敗しました。' },
      }
      return dispatch('http/get', { ...request }, { root: true }).then(
        (res) => {
          return res
        }
      )
    },
    // 登録済みの場所取得
    getPlace({ commit, dispatch }, { jyucyuId, type, id, hn }) {
      const query = {
        jyucyuId,
        type,
        id,
        hn,
      }
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.PLACE}?${stringify(query)}`,
        error: { message: '選択した登録済みの場所が存在しません。' },
      }
      return dispatch('http/get', { ...request }, { root: true })
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // 登録番号登録
    getNumberArea({ commit, dispatch }) {
      const request = {
        url: Constant.API_URL.NUMBER_MEI,
        error: { message: '登録番号の取得に失敗しました。' },
      }
      return dispatch('http/get', { ...request }, { root: true })
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // 車両メーカー一覧取得
    getSyaryoMakerList({ commit, dispatch }) {
      const request = {
        url: Constant.API_URL.SYARYO_MAKER,
        error: { message: '車両メーカーの取得に失敗しました。' },
      }
      return dispatch('http/get', { ...request }, { root: true })
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // 管轄運輸支局一覧取得
    getRikujiList({ commit, dispatch }) {
      const request = {
        url: Constant.API_URL.RIKUJI,
        error: { message: '管轄運輸支局の取得に失敗しました。' },
      }
      return dispatch('http/get', { ...request }, { root: true })
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // 前回の発注情報取得
    getLastJyucyu({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        params: data,
        url: `${Constant.API_URL.JYUCYU}/last_order`,
        error: { message: '前回の発注情報の取得に失敗しました。' },
      }
      return dispatch('http/post', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
    // 前回の発注情報取得
    getJyucyuFromId({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        params: data,
        url: `${Constant.API_URL.JYUCYU}/order`,
        error: { message: '発注情報の取得に失敗しました。' },
      }
      return dispatch('http/post', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
    // 貴社管理番号更新
    kisyaKanriBango({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        params: data,
        url: `${Constant.API_URL.JYUCYU}/updateKisyaKanriBango`,
        error: { message: '貴社管理番号の更新に失敗しました。' },
      }
      return dispatch('http/post', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
    // 最後に発注した車両1件を取得
    getLatestSyaryo({ commit, dispatch }) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        params: { latest: true },
        url: `${Constant.API_URL.JYUCYU_SYARYO}`,
        error: { message: '車両情報の取得に失敗しました。' },
      }
      return dispatch('http/post', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },

    /** POS番号情報取得 */
    getPos({ dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        params: data,
        url: Constant.API_URL.POS,
        error: { message: 'POS番号情報の取得に失敗しました。' },
      }
      return dispatch('http/get', { ...request }, { root: true }).then(
        (v) => v.data
      )
    },

    /** POS番号情報編集 */
    async updatePos({ dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.POS}/edit`,
        params: data,
        error: { message: '重複POSデータが存在する為、作成できません。' },
      }
      return dispatch('http/post', { ...request }, { root: true })
    },

    /** POS番号情報削除 */
    async deletePos({ dispatch }, { id, detailId }) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.POS}/delete/${id}/${detailId}`,
        error: { message: 'POS番号情報の削除に失敗しました。' },
      }
      return dispatch('http/get', { ...request }, { root: true })
    },

    // 発注問い合わせメール送信
    sendInquiryEmail({ dispatch }, data) {
      const request = {
        url: `${Constant.API_URL.JYUCYU_SYARYO}/${data.jyuchuSyaryoId}/send/inquiry_email`,
        params: data,
      }
      return dispatch('http/post', { ...request }, { root: true })
    },

    // 編集（キャンセル）可能か
    getIsUpdatable({ dispatch }, data) {
      const request = {
        url: `${Constant.API_URL.JYUCYU_SYARYO}/${data.jyuchuSyaryoId}/is_updatable`,
      }
      return dispatch('http/get', { ...request }, { root: true })
    },
  },
  data: () => ({}),
}



// WEBPACK FOOTER //
// ./src/store/modules/order.js